let history : any = undefined;
export class HistoryService {
  public static setRouterHistory(_history : any) {
    history = _history;
  }

  public static getRouterHistory() : any {
    return history;
  }  
}